import React, { useState } from 'react';

const FormularzAdresu = ({ onSave, onCancel, klientId }) => {
  const [addressData, setAddressData] = useState({
    kraj: '',
    ulica: '',
    nr_domu: '',
    nr_lokalu: '',
    kod_pocztowy: '',
    miasto: '',
    notatka: '',
    id_klient: klientId // Powiązanie adresu z klientem
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setAddressData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log('Wysyłane dane adresu:', addressData);
    onSave(addressData);
  };

  return (
    <form onSubmit={handleSubmit}>
        <div>
        <label>Kraj:
          <input name="kraj" value={addressData.kraj} onChange={handleInputChange} required />
        </label>
      </div>
      <div>
        <label>Miasto:
          <input name="miasto" value={addressData.miasto} onChange={handleInputChange} required />
        </label>
      </div>
      <div>
        <label>Ulica:
          <input name="ulica" value={addressData.ulica} onChange={handleInputChange} required />
        </label>
      </div>
      <div>
        <label>Numer domu:
          <input name="nr_domu" value={addressData.nr_domu} onChange={handleInputChange} required />
        </label>
      </div>
      <div>
        <label>Numer lokalu:
          <input name="nr_lokalu" value={addressData.nr_lokalu} onChange={handleInputChange} />
        </label>
      </div>
      <div>
        <label>Kod pocztowy:
          <input name="kod_pocztowy" value={addressData.kod_pocztowy} onChange={handleInputChange} required />
        </label>
      </div>
      <div>
        <label>Notatka:
          <input name="notatka" value={addressData.notatka} onChange={handleInputChange} />
        </label>
      </div>
      <div>
        <button type="submit">Dodaj adres</button>
        <button type="button" onClick={onCancel}>Anuluj</button>
      </div>
    </form>
  );
};

export default FormularzAdresu;
